import { axios } from "@/plugins/http-request.js";

const actions = {
  getPasUserList(context, payload) {
    return axios
      .get(`/api/gate_token/get`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  pasTimeline(context, id) {
    return axios
      .get(`/api/pas_gate_token/timeline/${id}`)
      .then((res) => res.data);
  },
  fetchStorelist() {
    return axios.get(`/api/pas_config_values`).then((res) => res.data);
  },
  forceCLoseApi(context, payload) {
    return axios.post(`/api/pas/force_close`, payload).then((res) => res.data);
  },
  downloadPasData(context, payload) {
    return axios
      .post(`/api/excel_download/gate_tokens`, payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadPasTemplate(_, link) {
    return axios
      .get(`${link}`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  bargraphData(_, payload) {
    return axios
      .get(`/api/pas-report-dashboard`, {
        params: payload,
      })
      .then((res) => res.data);
  },
};

export default {
  actions,
};
